export default "__VITE_ASSET__01ab015a__"